import React, { useState, useEffect } from "react";
import {Button, Col, Input, InputNumber, Row, Table, Form, Select} from "antd";
import moment from "moment";
import agros from "../../../../../const/api";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { convertColumns } from "../../../../../utils/columnconverter";
import { getOptions, notify } from "../../../../../redux/actions";
import {noWhitespace, whiteSpace} from "../../../../../utils/rules";

const { Option } = Select;

const Edit = (props) => {
    const { t,i18n } = useTranslation();
    const { getOptions } = props;
    const options = props.options[props.lang];
    const cols = [
        { key: "productName", value: t("name"), con: true },
        { key: "fertilizerKind", value: t("typeOf"), con: true },
        { key: "mainIngredient", value: t("activeSubstance"), con: true },
        { key: "quantity", value: t("quantityOf"), con: true },
        { key: "price", value: t("price"), con: true },
        { key: "documentNumber", value: t("documentNumber"), con: true },
        { key: "warehouseName", value: t("warehouse"), con: true },
        { key: "quantity", value: t("quantity"), con: true },
        { key: "operation", value: t("operation"), con: true },
        { key: "productName", value: t("productName"), con: true },
        { key: "takenPerson", value: t("person"), con: true },
        { key: "expireDate", value: t("expirationDate"), con: false },
        { key: "usedStatus", value: "", con: false },
        { key: "index", value: "", con: false },
    ];

    const [form] = Form.useForm();
    const { notify , workPlanId} = props;
    const [data, setData] = useState(undefined);
    const [stockId, setStockId] = useState(null);
    const [unit , setUnit] = useState('')
    const [vals, setVals] = useState({});
    const [selectedRows , setSelectedRows] = useState([])
    const [selectedRowKeys , setSelectedRowKeys] = useState([])
    const rowSelection = {
        type: props.modalType === 'export' ? 'checkbox' : "radio",
        onChange: (selectedRowKeys, selectedRows) =>{
            // inputChange()
            setStock(selectedRows , selectedRowKeys);
        },
        // onSelect: ()=>{inputChange()},
        selectedRowKeys,
        preserveSelectedRowKeys:true,
        hideSelectAll:true,
    }

    const handleKeyChange = (e, key) => {
        const all = { ...vals };
        all[key] = e;
        setVals(all);
    };

    const setStock = (selectedRows , selectedRowKeys) => {
        setSelectedRowKeys(selectedRowKeys)
        if (props.modalType !== 'export'){
          setStockId(selectedRows[0].stockId);
          form.setFieldsValue({
              quantity:selectedRows[0].quantitNumber,
              WarehouseId:options.warehouses.find((w)=>{return w.name === selectedRows[0].warehouseName}).id
          })
          setUnit(selectedRows[0].measurementUnit)
      }
      if (props.modalType === 'export'){
          // inputChange()
          setSelectedRows(selectedRows)
      }
    };

    // const inputChange =  () =>{
    //     let StockInfo = form.getFieldsValue().StockInfo;
    //     if (StockInfo){
    //         console.log(StockInfo)
    //         let total  = 0;
    //         // eslint-disable-next-line array-callback-return
    //         StockInfo.map((s) => {
    //             total += parseInt(s.Quantity)
    //         })
    //     }
    // }

    useEffect(() => {
        setSelectedRowKeys([])
        form.resetFields()
        setSelectedRows([])
        getOptions(
            [
                "fertilizers",
                "fertilizerKinds",
                "mainIngredients",
                "customers",
                "warehouses",
                "parcelCategories",
                "parcels",
                "parcelSectors",
            ],
            props.options,
            i18n.language
        );
        if (props.modalType === 'export'){
            form.setFieldsValue({
                parcelCategoryId:props.parcelCategory,
                parcelId: props.parcel,
                ParcelSectorIds: props.parcelSectors
            })
        }
        agros.get(`MedicalStock/${props.id}`).then((res) => {
            let data  = res.data
            if (props.modalType === 'export'){
                data = res.data.filter((d) => {return d.quantity !== 0})
            }
            setData(
                data.map((r, index) => {
                    return { ...r, key: index + 1, index, tableIndex: index + 1 ,
                        quantitNumber: r.quantity ,
                        quantity:
                            r.quantity + (r.measurementUnit ? " " + r.measurementUnit : null),
                        expireDate:
                            r.expireDate && moment(r.expireDate).format("DD-MM-YYYY"),
                        documentNumber: r.documentNumber !== null ? r.documentNumber : "-",
                    };
                })
            )
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [t , props.id , props.visibleEdit , props.modalType]);

    // table data columns
    const columns = [
        {
            title: t("name"),
            key: 1,
            dataIndex: "productName",
        },
        {
            title: t("typeOf"),
            key: 2,
            dataIndex: "fertilizerKind",
        },
        {
            title: t("activeSubstance"),
            key: 3,
            dataIndex: "mainIngredient",
        },
        {
            title: t("quantityOf"),
            key: 4,
            dataIndex: "quantity",
        },
        {
            title: t("expirationDate"),
            key: 5,
            dataIndex: "expireDate",
        },
        {
            title: t("price"),
            key: 6,
            dataIndex: "price",
        },
        {
            title: t("finalPrice"),
            key: 6,
            dataIndex: "totalPrice",
        },
        {
            title: t("warehouse"),
            key: 7,
            dataIndex: "warehouseName",
        },
    ];


    const saveExport = (values) => {
        console.log(values)
       if (props.modalType === 'edit'){
           if (stockId) {
               agros
                   .put(     `MedicalStock/${stockId}`, { ...values, stockId })
                   .then((res) => {
                       notify("", true);
                       setSelectedRows([])
                       props.setVisibleEdit(false);
                       props.triggerFetch();
                   })
                   .catch((err) => {
                       notify(err.response, false);
                   });
           } else {
               notify("", false);
           }
       }
       if (props.modalType === 'transfer'){
           agros
               .post(     `MedicalStock/Transfer`, { ...values, stockId })
               .then((res) => {
                   notify("", true);
                   setSelectedRows([])
                   props.setVisibleEdit(false);
                   props.triggerFetch();
               })
               .catch((err) => {
                   notify(err.response, false);
               });
       }
       if (props.modalType === 'export'){
           agros
               .post("medicalstock/export", { ...values, workPlanId})
               .then((res) => {
                   notify("", true);
                   props.setVisibleEdit(false);
                   setSelectedRows([])
                   // props.triggerFetch();
               })
               .catch((err) => {
                   notify(err.response, false);
               });
       }
    };

    return (
        <>
            <Row>
                <Col span={24}>
                    {data &&
                        <Table
                            size="small"
                            className="w-100"
                            columns={columns}
                            rowSelection={rowSelection}
                            dataSource={convertColumns(data, cols)}
                            pagination={{ pageSize: 5, current_page: 1 }}
                        />
                    }
                    {props.modalType === 'export' &&    <h3 className="red mb-5">Tələb olunan miqdar  {props.quantity + ' ' +  props.unit} dir.</h3>}
                </Col>
            </Row>

            <Form form={form} layout="vertical" onFinish={saveExport}>
                <div>
                    <Row gutter={[16, 8]}>
                        {props.modalType === 'export' &&
                            <>
                                <Col span={24}>
                                    <Row  gutter={[16, 16]}>
                                        {selectedRows.map((p , i)=>(
                                            <Col key={i} lg={4} md={12}>
                                                <div className={'animated zoomIn p-2 border'}>
                                                    <Row className={'flex-a'} gutter={[16,8]}>
                                                        <Col lg={24} sm={12} xs={24}>
                                                            <Form.Item
                                                                className={'d-none'}
                                                                initialValue={p.stockId}
                                                                validateTrigger="onChange"
                                                                name={[
                                                                    "StockInfo",
                                                                    i,
                                                                    "stockId",
                                                                ]}
                                                                rules={[noWhitespace(t("inputError"))]}
                                                            >
                                                                <Input type={'hidden'}  className="w-100" />
                                                            </Form.Item>
                                                            <div className="form-lang">
                                                                <p className="flex mb-5 flex-between">
                                                                    <p> {t("quantityOf")}</p>
                                                                    <p>{p.warehouseName}</p>
                                                                </p>
                                                                <Form.Item
                                                                    initialValue={p.quantitNumber}
                                                                    validateTrigger="onChange"
                                                                    name={[
                                                                        "StockInfo",
                                                                        i,
                                                                        "Quantity",
                                                                    ]}
                                                                    rules={[noWhitespace(t("inputError"))]}
                                                                >
                                                                    <InputNumber
                                                                           // onChange={()=>{inputChange()}}
                                                                           max={p.quantitNumber} className="w-100" />
                                                                </Form.Item>
                                                                <span className="input-lang btm">
                                                                    {p.measurementUnit}
                                                                </span>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Col>
                                        ))}
                                    </Row>
                                </Col>
                                <Col lg={8} sm={12} xs={24}>
                                    <Form.Item
                                        label={t("areaCategory")}
                                        validateTrigger="onChange"
                                        name="parcelCategoryId"
                                        rules={[noWhitespace(t("inputError"))]}
                                    >
                                        <Select
                                            disabled
                                            onChange={(e) => handleKeyChange(e, "parcelCategoryId")}
                                        >
                                            {options.parcelCategories.map((pc, index) => {
                                                return (
                                                    <Option key={index} value={pc.id}>
                                                        {pc.name}
                                                    </Option>
                                                );
                                            })}
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col lg={8} sm={12} xs={24}>
                                    <Form.Item
                                        label={t("area")}
                                        validateTrigger="onChange"
                                        name="parcelId"
                                        rules={[noWhitespace(t("inputError"))]}
                                    >
                                        <Select disabled onChange={(e) => handleKeyChange(e, "parcelId")}>
                                            {options.parcels
                                                // .filter((p) => p.parcelCategoryId === vals.parcelCategoryId)
                                                .map((pc, index) => {
                                                    return (
                                                        <Option key={index} value={pc.id}>
                                                            {pc.name}
                                                        </Option>
                                                    );
                                                })}
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col lg={8} sm={12} xs={24}>
                                    <Form.Item
                                        label={t("areasSector")}
                                        validateTrigger="onChange"
                                        name="ParcelSectorIds"
                                        rules={[noWhitespace(t("inputError"))]}
                                    >
                                        <Select
                                            mode="multiple"
                                            disabled={props.parcelSectors}
                                        >
                                            {options.parcelSectors
                                                .filter((p) => p.parcelId === props.parcel)
                                                .map((pc, index) => {
                                                    return (
                                                        <Option key={index} value={pc.id}>
                                                            {pc.name}
                                                        </Option>
                                                    );
                                                })}
                                        </Select>
                                    </Form.Item>
                                </Col>
                            </>
                        }

                        {props.modalType !== 'export' &&
                        <Col lg={8} sm={12} xs={24}>
                            <div className="form-lang">
                                <Form.Item
                                    label={t("quantityOf")}
                                    validateTrigger="onChange"
                                    name="quantity"
                                    rules={[noWhitespace(t("inputError"))]}
                                >
                                    <InputNumber  className="w-100" />
                                </Form.Item>
                                <span className="input-lang btm">
                                    {unit}
                                </span>
                            </div>
                        </Col>
                        }
                        {props.modalType === 'transfer' &&
                             <Col md={6} sm={12} xs={24}>
                            <Form.Item
                                name="WarehouseId"
                                label={t("warehouse")}
                                validateTrigger="onChange"
                            >
                                <Select
                                    showSearch
                                    notFoundContent={null}
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                    filterSort={(optionA, optionB) =>
                                        optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                                    }
                                    // onChange={(e)=>{handleFertilizerChange(e)}}
                                >
                                    {options.warehouses.map((c, index) => {
                                        return (
                                            <Option key={index} value={c.id}>
                                                {c.name}
                                            </Option>
                                        );
                                    })}
                                </Select>
                            </Form.Item>
                        </Col>
                        }
                        {props.modalType === 'export' &&
                            <>
                                <Col lg={8} sm={12} xs={24}>
                                    <Form.Item
                                        label={t("acceptedPerson")}
                                        validateTrigger="onChange"
                                        name="handingPerson"
                                        rules={[whiteSpace(t("inputError"))]}
                                    >
                                        <Input size={'large'}/>
                                    </Form.Item>
                                </Col>
                                <Col lg={8} sm={12} xs={24}>
                                    <Form.Item
                                        label={t("acceptedCarNumber")}
                                        validateTrigger="onChange"
                                        name="handingCarNumber"
                                        rules={[whiteSpace(t("inputError"))]}
                                    >
                                        <Input size={'large'}/>
                                    </Form.Item>
                                </Col>
                            </>
                        }

                    </Row>
                    <div
                        className="modalButtons"
                        style={{ position: "absolute", bottom: "20px", right: "25px" }}
                    >
                        <Button onClick={() => {props.setVisibleEdit(false)  ; setSelectedRows([]) }}>
                            {t("cancel")}
                        </Button>
                        <Button  type="primary" className="ml-10" htmlType="submit">
                            {t("save")}
                        </Button>
                    </div>
                </div>
            </Form>
        </>
    );
};

const mapStateToProps = ({ options, lang }) => {
    return { options, lang };
};

export default connect(mapStateToProps, { getOptions, notify })(Edit);
